module.exports = __webpack_public_path__ + "static/img/1.3877788.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer4/ban-pt/1.jpg
// module id = 5O8E
// module chunks = 1